import React, { useState, useEffect } from "react";
import { Link, Navigate, useParams } from 'react-router-dom'
import Scroll from 'react-scroll';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUsers, faTachometer, faEye, faPencil, faArrowLeft, faCheckCircle } from '@fortawesome/free-solid-svg-icons'
import { useRecoilState } from 'recoil';

import { putUserChangePasswordOperationAPI } from "../../API/User";
import FormErrorBox from "../Reusable/FormErrorBox";
import FormInputField from "../Reusable/FormInputField";
import PageLoadingContent from "../Reusable/PageLoadingContent";
import { topAlertMessageState, topAlertStatusState, userDetailState } from "../../AppState";


function UserUpdateForChangePassword() {
    ////
    //// URL Parameters.
    ////

    const { id } = useParams()

    ////
    //// Global state.
    ////

    const [topAlertMessage, setTopAlertMessage] = useRecoilState(topAlertMessageState);
    const [topAlertStatus, setTopAlertStatus] = useRecoilState(topAlertStatusState);
    const [user] = useRecoilState(userDetailState);

    ////
    //// Component states.
    ////

    const [errors, setErrors] = useState({});
    const [forceURL, setForceURL] = useState("");
    const [isFetching, setFetching] = useState(false);
    const [password, setPassword] = useState("");
    const [passwordRepeated, setPasswordRepeated] = useState("");

    ////
    //// API.
    ////

    function onUserUpdateSuccess(response){
        console.log("onUserUpdateSuccess: Starting..."); // For debugging purposes only.

        // Update notification.
        setTopAlertStatus("success");
        setTopAlertMessage("User password changed");
        setTimeout(() => {
            console.log("onUserUpdateSuccess: topAlertMessage, topAlertStatus:", topAlertMessage, topAlertStatus);
            setTopAlertMessage("");
        }, 2000);

        // Fetch again an updated list.
        setForceURL("/user/" + id);
    }

    function onUserUpdateError(apiErr) {
        console.log("onUserUpdateError: Starting..."); // For debugging purposes only.
        setErrors(apiErr);

        // Update notification.
        setTopAlertStatus("danger");
        setTopAlertMessage("Failed deleting");
        setTimeout(() => {
            console.log("onUserUpdateError: topAlertMessage, topAlertStatus:", topAlertMessage, topAlertStatus);
            setTopAlertMessage("");
        }, 2000);

        // The following code will cause the screen to scroll to the top of
        // the page. Please see ``react-scroll`` for more information:
        // https://github.com/fisshy/react-scroll
        var scroll = Scroll.animateScroll;
        scroll.scrollToTop();
    }

    function onUserUpdateDone() {
        console.log("onUserUpdateDone: Starting...");
        setFetching(false);
    }

    ////
    //// Event handling.
    ////

    const onSubmitClick = (e) => {
        console.log("onSubmitClick: Beginning...");
        setErrors({});
        setFetching(true);

        // To Snake-case for API from camel-case in React.
        // const postData = {
        //     id: id,
        //     password: password,
        //     password_repeated: passwordRepeated,
        // };
        // Update the user.
        console.log("onSubmitClick, user:", user);
        putUserChangePasswordOperationAPI(id, password, passwordRepeated, onUserUpdateSuccess, onUserUpdateError, onUserUpdateDone);
    }

    ////
    //// Misc.
    ////

    useEffect(() => {
        let mounted = true;

        if (mounted) {
            window.scrollTo(0, 0);  // Start the page at the top of the page.
        }

        return () => { mounted = false; }
    }, [id]);

    ////
    //// Component rendering.
    ////

    if (forceURL !== "") {
        return <Navigate to={forceURL}  />
    }

    return (
        <>
            <div class="container">
                <section class="section">
                    {/* Desktop Breadcrumbs */}
                    <nav class="breadcrumb is-hidden-touch" aria-label="breadcrumbs">
                        <ul>
                            <li><Link to="/dashboard"><FontAwesomeIcon className="fas" icon={faTachometer} />&nbsp;Dashboard</Link></li>
                            <li class=""><Link to="/users" aria-current="page"><FontAwesomeIcon className="fas" icon={faUsers} />&nbsp;Users</Link></li>
                            <li class=""><Link to={`/user/${id}`} aria-current="page"><FontAwesomeIcon className="fas" icon={faEye} />&nbsp;Detail</Link></li>
                            <li class="is-active"><Link to={`/user`} aria-current="page"><FontAwesomeIcon className="fas" icon={faPencil} />&nbsp;Change Password</Link></li>
                        </ul>
                    </nav>

                    {/* Mobile Breadcrumbs */}
                    <nav class="breadcrumb is-hidden-desktop" aria-label="breadcrumbs">
                        <ul>
                            <li class=""><Link to={`/user/${id}`} aria-current="page"><FontAwesomeIcon className="fas" icon={faArrowLeft} />&nbsp;Back to Detail</Link></li>
                        </ul>
                    </nav>

                    {/* Content */}
                    <nav class="box">
                        <p class="title is-4"><FontAwesomeIcon className="fas" icon={faUsers} />&nbsp;User - {user.firstName} {user.lastName}</p>
                        {isFetching
                            ?
                            <PageLoadingContent displayMessage={"Please wait"} />
                            :
                            <>
                                <FormErrorBox errors={errors} />
                                <div class="columns">
                                    <div class="column">
                                        <p class="subtitle is-6"><FontAwesomeIcon className="fas" icon={faPencil} />&nbsp;Change Password</p>

                                        <FormInputField
                                            label="Password"
                                            name="password"
                                            type="password"
                                            placeholder="Text input"
                                            value={password}
                                            errorText={errors && errors.password}
                                            helpText=""
                                            onChange={(e)=>setPassword(e.target.value)}
                                            isRequired={true}
                                            maxWidth="380px"
                                        />

                                        <FormInputField
                                            label="Password Repeated"
                                            name="passwordRepeated"
                                            type="password"
                                            placeholder="Text input"
                                            value={passwordRepeated}
                                            errorText={errors && errors.passwordRepeated}
                                            helpText=""
                                            onChange={(e)=>setPasswordRepeated(e.target.value)}
                                            isRequired={true}
                                            maxWidth="380px"
                                        />

                                        <div class="columns">
                                            <div class="column is-half">
                                                <Link to={`/user/${id}`} class="button is-fullwidth-mobile"><FontAwesomeIcon className="fas" icon={faArrowLeft} />&nbsp;Back to User</Link>
                                            </div>
                                            <div class="column is-half has-text-right">
                                                <button onClick={onSubmitClick}  class="button is-primary is-fullwidth-mobile"><FontAwesomeIcon className="fas" icon={faCheckCircle} />&nbsp;Save</button>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </>
                        }
                    </nav>
                </section>
            </div>
        </>
    );
}

export default UserUpdateForChangePassword;
